import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import {SalesSelectConditionsComponent} from "./sales-select-conditions.component";
import {PrimengModule} from "../../shared/primeng-module/primeng.module";
import {LibraryModule} from "../../../../../../library/src/lib/library.module";
import {GeneralModule} from "../general/general.module";



@NgModule({
  declarations: [
    SalesSelectConditionsComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    PrimengModule,
    LibraryModule,
    GeneralModule,
  ],
  exports: [
    SalesSelectConditionsComponent
  ]
})
export class SalesSelectConditionsModule { }
